<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-primary">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-8 pointer" @click="toggleSettings">
                            <h5>Unterschrift (#{{ element.key }})</h5>
                        </div>
                        <div class="col-md-4 text-right">
                            <button class="btn btn-sm btn-primary"
                                    :class="{ disabled: $parent.hasLowestSort(element) }"
                                    :disabled="$parent.hasLowestSort(element)"
                                    @click="$parent.moveElementUp(element)">
                                <i class="fas fa-arrow-up"></i>
                            </button>
                            <button class="btn btn-sm btn-primary mr-4"
                                    :class="{ disabled: $parent.hasHighestSort(element) }"
                                    :disabled="$parent.hasHighestSort(element)"
                                    @click="$parent.moveElementDown(element)">
                                <i class="fas fa-arrow-down"></i>
                            </button>
                            <button @click="$parent.removeElementByKey(element.key)" class="btn btn-danger btn-sm">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body" v-if="this.showSettings">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="textInput">Anzuzeigender Text</label>
                            <input type="text" id="textInput" class="form-control" placeholder="Geben Sie hier den Text ein, der vor dem Unterschriften-Feld angezeigt wird" v-model="element.text">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BuilderSignatureElement",
        props: ['element'],
        data() {
            return {
                showSettings: true
            }
        },
        methods: {
            toggleSettings() {
                this.showSettings = !this.showSettings;
            }
        }
    }
</script>

<style scoped>
    .badge {
        cursor: pointer;
    }
    label {
        font-style: italic;
    }

</style>
